;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c5b3163f-763f-4708-88ae-cca5893b118a",e._sentryDebugIdIdentifier="sentry-dbid-c5b3163f-763f-4708-88ae-cca5893b118a")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2244],{

/***/ 90480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgStarFilled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "star-filled_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M0 .5h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#star-filled_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.854 18l1.354-5.854L1.667 8.21l6-.521L10 2.167l2.333 5.52 6 .522-4.541 3.937L15.146 18 10 14.896 4.854 18z",
    fill: "currentColor"
  }))));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgStarFilled);

/***/ }),

/***/ 73692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgStarHalf(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "star-half_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M0 .5h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#star-half_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.625 14.542l-.688-3 2.313-2-3.042-.27L10 6.437v6.5l2.625 1.604zM4.855 18l1.353-5.854L1.667 8.21l6-.521L10 2.167l2.333 5.52 6 .522-4.541 3.937L15.146 18 10 14.896 4.854 18z",
    fill: "currentColor"
  }))));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgStarHalf);

/***/ }),

/***/ 23999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "star_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M0 .5h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#star_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.375 14.521L10 12.938l2.625 1.604-.688-3 2.313-2-3.042-.27L10 6.437 8.792 9.25l-3.042.271 2.312 2.021-.687 2.98zm-2.52 3.48l1.353-5.855L1.667 8.21l6-.521L10 2.167l2.333 5.52 6 .522-4.541 3.937L15.146 18 10 14.896 4.854 18z",
    fill: "currentColor"
  }))));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgStar);

/***/ }),

/***/ 60925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getJudgeMeRatings; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_http_status__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73382);
/* harmony import */ var utils_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21744);





/**
 * Get reviews for products from judge me cache server.
 * Available only on client side.
 * @SEE : https://help.judge.me/en/articles/8409211-retrieving-cached-widgets-from-the-judge-me-cache-server
 */ var getJudgeMeRatings = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var externalIds, response, _tmp, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalIds = param.externalIds;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("https://cache.judge.me/widgets/shopify/".concat("jzk1.myshopify.com"), (_tmp.params = {
                            public_token: "H_wgWW_5Y6On2s2rCScBCJy",
                            preview_badge_product_ids: externalIds.toString()
                        }, _tmp.errorHandling = {
                            statusesToOmit: [
                                constants_http_status__WEBPACK_IMPORTED_MODULE_1__/* .HttpStatus.NOT_FOUND */ .o.NOT_FOUND,
                                constants_http_status__WEBPACK_IMPORTED_MODULE_1__/* .HttpStatus.TOO_MANY_REQUESTS */ .o.TOO_MANY_REQUESTS
                            ]
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.data) throw new Error("Details not found");
                    return [
                        2,
                        response.data.preview_badges
                    ];
                case 3:
                    e = _state.sent();
                    if ((0,utils_axios__WEBPACK_IMPORTED_MODULE_2__/* .isAxiosError */ .IZ)(e)) {
                        console.error("getJudgeMeRatings", e);
                    }
                    return [
                        2,
                        undefined
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getJudgeMeRatings(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 99108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ isSmartCollectionResponse; },
/* harmony export */   "n": function() { return /* binding */ isSmartCollectionItem; }
/* harmony export */ });
/**
 * Type guard for SmartCollectionResponse
 */ function isSmartCollectionResponse(input) {
    return input !== null && typeof input === "object" && "items" in input && Array.isArray(input.items);
}
/**
 * Type guard for SmartCollectionResponse
 */ function isSmartCollectionItem(input) {
    return input !== null && typeof input === "object" && "product_title" in input && typeof input.product_title === "string";
}


/***/ }),

/***/ 42657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69779);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_judge_me__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60925);
/* harmony import */ var assets_icons_star_filled_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90480);
/* harmony import */ var assets_icons_star_half_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73692);
/* harmony import */ var assets_icons_star_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23999);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var contexts_reviews_test__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44012);
/* harmony import */ var stores_reviews_cache__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32889);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8100);
/* harmony import */ var utils_judge_me__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8181);

















/**
 * Display JudgeMe ratings.
 * In order to reduce the request to API, the component priorities to utilize review props given from parent component.
 */ var JudgeMePreviewBadge = function(param) {
    var _hideNumberOfReviews = param.hideNumberOfReviews, hideNumberOfReviews = _hideNumberOfReviews === void 0 ? false : _hideNumberOfReviews, _numberDisplayType = param.numberDisplayType, numberDisplayType = _numberDisplayType === void 0 ? "unit" : _numberDisplayType, productId = param.productId, _starSize = param.starSize, starSize = _starSize === void 0 ? "medium" : _starSize, onClick = param.onClick;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), isTimeOut = ref1[0], setIsTimeout = ref1[1];
    var reviews = (0,stores_reviews_cache__WEBPACK_IMPORTED_MODULE_8__/* .useReviewsCacheStore */ .g)().reviews;
    var ref2 = (0,contexts_reviews_test__WEBPACK_IMPORTED_MODULE_6__/* .useReviewsTest */ .D)(), testData5970 = ref2.testData5970, testData5971 = ref2.testData5971;
    var review = reviews[productId];
    var starSizeClass = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        if (starSize === "small") return "h-5 w-5";
        if (starSize === "medium") return "h-6 w-6";
    }, [
        starSize
    ]);
    var productData = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        if (testData5971 && testData5971.productData[productId]) {
            return testData5971.globalReviewCount;
        } else if (testData5970 && testData5970[productId]) {
            return testData5970[productId];
        }
        return null;
    }, [
        productId,
        testData5970,
        testData5971
    ]);
    setTimeout(function() {
        setIsTimeout(true);
    }, 2000);
    // When used on CDP in which there are too many occurrences, judgeMe api returns 429 error.
    // Refetch after error interval to show the value even after first error.
    var ref3 = (0,swr__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, review), {
        productId: productId,
        isTimeOut: isTimeOut
    }), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(arg) {
            var _tmp, rawReviews, _tmp1, parsed, _tmp2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(arg.ratingCount && arg.reviewsCount)) return [
                            3,
                            1
                        ];
                        _tmp = {};
                        return [
                            2,
                            (_tmp.ratingCount = arg.ratingCount, _tmp.reviewsCount = arg.reviewsCount, _tmp)
                        ];
                    case 1:
                        if (!isTimeOut) return [
                            3,
                            3
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            (0,api_judge_me__WEBPACK_IMPORTED_MODULE_1__/* .getJudgeMeRatings */ .U)((_tmp1.externalIds = [
                                arg.productId
                            ], _tmp1))
                        ];
                    case 2:
                        rawReviews = _state.sent();
                        if (!rawReviews) {
                            return [
                                2,
                                undefined
                            ];
                        }
                        _tmp2 = {};
                        parsed = (0,utils_judge_me__WEBPACK_IMPORTED_MODULE_14__/* .parseReviews */ .m)((_tmp2.rawReviews = rawReviews, _tmp2));
                        return [
                            2,
                            Object.values(parsed)[0]
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(arg) {
            return _ref.apply(this, arguments);
        };
    }(), {
        errorRetryCount: 2,
        onSuccess: function() {
            return setIsLoading(false);
        }
    }), productJudgeMe = ref3.data;
    if (isLoading && !productJudgeMe) return null;
    if (!productJudgeMe) return null;
    var ratingCount = productJudgeMe.ratingCount, reviewsCount = productJudgeMe.reviewsCount;
    var ref4;
    var rating = Number((ref4 = productData === null || productData === void 0 ? void 0 : productData.ratingCount) !== null && ref4 !== void 0 ? ref4 : ratingCount) || 0;
    var fullStars = Math.floor(rating);
    var halfStar = 0;
    var offStars = 0;
    if (rating % 1 >= 0.25 && rating % 1 <= 0.75) {
        halfStar = 1;
        offStars = 5 - fullStars - halfStar;
    } else if (rating % 1 > 0.74) {
        fullStars += 1;
        offStars = 5 - fullStars;
    } else {
        offStars = 5 - fullStars;
    }
    if (Number(reviewsCount) === 0) return null;
    var ref5, ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: "flex items-center text-sm text-text-secondary",
        "data-test": "judge-me",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex text-yellow-400",
                children: [
                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(Array(fullStars)).map(function(_, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(assets_icons_star_filled_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(starSizeClass)
                        }, i);
                    }),
                    halfStar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(assets_icons_star_half_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(starSizeClass)
                    }) : null,
                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(Array(offStars)).map(function(_, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(assets_icons_star_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(starSizeClass)
                        }, i + fullStars + halfStar);
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "ml-1",
                children: (Number((ref5 = productData === null || productData === void 0 ? void 0 : productData.ratingCount) !== null && ref5 !== void 0 ? ref5 : ratingCount) || 0).toFixed(2)
            }),
            !hideNumberOfReviews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "ml-1.5",
                children: numberDisplayType === "unit" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    id: "pdp:product-title:ratings",
                    values: {
                        count: (ref6 = productData === null || productData === void 0 ? void 0 : productData.reviewsCount) !== null && ref6 !== void 0 ? ref6 : reviewsCount
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: "(".concat((ref7 = productData === null || productData === void 0 ? void 0 : productData.reviewsCount) !== null && ref7 !== void 0 ? ref7 : reviewsCount, ")")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JudgeMePreviewBadge);


/***/ }),

/***/ 42421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ECO_OPTION_ID; },
/* harmony export */   "u": function() { return /* binding */ PetTag; }
/* harmony export */ });
var PetTag = {
    /** Tag associated with dog product */ Dog: "F\xfcr Hunde",
    /** Tag associated with cat product */ Cat: "F\xfcr Katzen"
};
/** ID associated with the product 'Eco Option' */ var ECO_OPTION_ID =  true ? 28539316338722 : 0;


/***/ }),

/***/ 45991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ CollectionProduct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(75815);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/product/getSmartColleciton/utils/index.ts
var utils = __webpack_require__(99108);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(92918);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./src/constants/segmentation.ts
var constants_segmentation = __webpack_require__(6813);
;// CONCATENATED MODULE: ./src/models/collection/utils/getPersonalizedSubtitle/index.tsx



var _obj;
var SubtitleMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Intolerance */.f0.Intolerance, "Ideal f\xfcr Hunde mit Unvertr\xe4glichkeiten"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Digestion */.f0.Digestion, "Ideal f\xfcr Hunde mit Verdauungsproblemen"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.PickyEater */.f0.PickyEater, "Ideal f\xfcr Hunde mit w\xe4hlerischem Essverhalten"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Welpe */.f0.Welpe, "F\xfcr Welpen"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.DogSenior */.f0.DogSenior, "Geeignet f\xfcr Senioren"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.SkinFur */.f0.SkinFur, "Ideal f\xfcr Hunde mit Haut- und Fellproblemen"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Overweight */.f0.Overweight, "Ideal f\xfcr Hunde mit \xdcbergewicht"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Bulldog */.f0.Bulldog, "Ideal f\xfcr Bulldoggen"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Chihuahua */.f0.Chihuahua, "Ideal f\xfcr Chihuahuas"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Dachshund */.f0.Dachshund, "Ideal f\xfcr Dackel"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Herdingdog */.f0.Herdingdog, "Ideal f\xfcr H\xfctehunde"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Havanese */.f0.Havanese, "Ideal f\xfcr Maltese & Havaneser"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Poodle */.f0.Poodle, "Ideal f\xfcr Pudel"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Retriever */.f0.Retriever, "Ideal f\xfcr Retriever"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.ShepherdDog */.f0.ShepherdDog, "Ideal f\xfcr Sch\xe4ferhunde"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Spitz */.f0.Spitz, "Ideal f\xfcr Spitz"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Terrier */.f0.Terrier, "Ideal f\xfcr Terrier"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.CatPickyEater */.f0.CatPickyEater, "Ideal f\xfcr Katzen mit w\xe4hlerischem Essverhalten"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.CatDigestion */.f0.CatDigestion, "Ideal f\xfcr Katzen mit Verdauungsproblemen"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.CatOverweight */.f0.CatOverweight, "Ideal f\xfcr Katzen mit \xdcbergewicht"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Sterilized */.f0.Sterilized, "Ideal f\xfcr sterilisierte Katzen"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Outdoor */.f0.Outdoor, "Ideal f\xfcr Freig\xe4nger"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.Kitten */.f0.Kitten, "Ideal f\xfcr Kitten 2-12 Monate"), (0,_define_property/* default */.Z)(_obj, constants_segmentation/* SegmentationIds.CatSenior */.f0.CatSenior, "Ideal f\xfcr Senioren"), _obj);
/**
 * Function to get getPersonalizedSubtitle for old collection product
 */ var getPersonalizedSubtitle = function(param) {
    var tags = param.tags, segmentation = param.segmentation;
    // First try exact match
    var exactEntry = Object.entries(constants_segmentation/* SEGMENTS_RAW_FILTER_MAP */.mE).find(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
        return value === segmentation;
    });
    // If no exact match, try array match
    var arrayEntry = !exactEntry ? Object.entries(constants_segmentation/* SEGMENTS_RAW_FILTER_MAP */.mE).find(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
        return Array.isArray(value) && value.includes(segmentation);
    }) : null;
    var entry = exactEntry || arrayEntry;
    if (!entry) return undefined;
    var segmentTag = tags.find(function(tag) {
        return tag === entry[0];
    });
    if (!segmentTag) return undefined;
    return SubtitleMap[segmentation];
};
/* harmony default export */ var utils_getPersonalizedSubtitle = (getPersonalizedSubtitle);

;// CONCATENATED MODULE: ./src/models/collection/collection.tsx










var getResizedImageUrl = function(url, size) {
    var lastDot = url.lastIndexOf(".");
    var resizedUrl = "".concat(url.substr(0, lastDot), "_").concat(String(size), "x").concat(url.substr(lastDot));
    return resizedUrl;
};
var sortVariants = function(a, b) {
    return +a.priceV2.amount - +b.priceV2.amount;
};
function assertIsStaticPDPProduct(data) {
    if (typeof data !== "object" || data === null) {
        return false;
    }
    if (!(0,utils/* isSmartCollectionItem */.n)(data) && (typeof data["pk"] !== "undefined" || typeof data["objectID"] !== "undefined")) {
        return false;
    }
    return true;
}
function assertIsSmartCollectionProduct(product) {
    if (typeof product !== "object" || product === null) {
        return false;
    }
    var prod = product;
    if (typeof prod.subtitle !== "string") {
        return false;
    }
    if (prod.bestseller !== undefined && typeof prod.bestseller === "boolean") {
        return false;
    }
    return true;
}
var MetafieldNameSpaces;
(function(MetafieldNameSpaces) {
    MetafieldNameSpaces["Petsdeli"] = "petsdeli";
    MetafieldNameSpaces["Subscription"] = "subscription";
    MetafieldNameSpaces["Accentuate"] = "accentuate";
    MetafieldNameSpaces["Rating"] = "rating";
})(MetafieldNameSpaces || (MetafieldNameSpaces = {}));
/** Common Product interface */ var CollectionProduct = function CollectionProduct(product, shouldIgnoreSubtitle) {
    "use strict";
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, CollectionProduct);
    var _obj;
    /** Make it private to hide implementation  */ this.metadata = (_obj = {}, (0,_define_property/* default */.Z)(_obj, MetafieldNameSpaces.Accentuate, {}), (0,_define_property/* default */.Z)(_obj, MetafieldNameSpaces.Subscription, {}), (0,_define_property/* default */.Z)(_obj, MetafieldNameSpaces.Rating, {}), (0,_define_property/* default */.Z)(_obj, MetafieldNameSpaces.Petsdeli, {}), _obj);
    this.image = {};
    this.getIsSmartCollectionItem = function() {
        return _this.isSmartCollectionItem;
    };
    this.getSlugifiedTags = function() {
        return _this.tags.map(strings/* slugify */.lV);
    };
    this.getProductTitle = function() {
        return _this.title || _this.metadata.accentuate.mainTitle;
    };
    /**
   * get subtitle for collection item
   * Since for cat collection, BE can't generate subtitle, subtitle is decided based on tags
   */ this.getProductSubtitle = function() {
        var segmentation = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).segmentation;
        if (!_this.shouldIgnoreSubtitle && !_this.isStaticCollectionItem) {
            return _this.subTitle;
        }
        if (segmentation) {
            var subtitle = utils_getPersonalizedSubtitle({
                segmentation: segmentation,
                tags: _this.tags
            });
            if (subtitle) return subtitle;
        }
        var _subTitle;
        return (_subTitle = _this.subTitle) !== null && _subTitle !== void 0 ? _subTitle : _this.metadata.accentuate.subTitle;
    };
    this.getRibbon = function() {
        if (_this.metadata["accentuate"].ribbonText1) {
            return {
                ribbonText: _this.metadata["accentuate"].ribbonText1,
                ribbonText2: _this.metadata["accentuate"].ribbonText2,
                ribbonColor: _this.metadata["accentuate"].ribbonColor
            };
        } else {
            return {
                ribbonText: _this.ribbonText,
                ribbonColor: _this.ribbonColor
            };
        }
    };
    this.getIsBestSeller = function() {
        var segment = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).segment;
        if (_this.segmentation && segment) {
            var key = typeof segment === "string" ? segment : segment.lastSegmentation;
            if (key && _this.segmentation && _this.segmentation[key]) {
                return !!_this.segmentation[key].isBestSeller;
            }
        }
        return !!_this.isBestSeller;
    };
    /**
   * Check if from price e.g "ab 19.99" should be shown
   */ this.getShouldShowFromPrice = function() {
        return _this.variantLength > 1 || _this.variants.length > 1;
    };
    /**
   * Retrieve weight string from variant title.
   * Variant title are conventionally named in the form of "[weight per one product] / [packing unit]"
   * e.g "200g / Einzeldose" , "Huhn / 12 x 400g"
   */ this.getWeights = function() {
        var _variantTitles;
        var titles = _this.isSmartCollectionItem ? (_variantTitles = _this.variantTitles) !== null && _variantTitles !== void 0 ? _variantTitles : [] : _this.variants.map(function(v) {
            return v.title;
        });
        var trimmed = titles.map(function(t) {
            return t.split("/")[0].trim();
        });
        if (_this.isSmartCollectionItem) {
            return Array.from(new Set(trimmed));
        }
        return trimmed.filter(function(weight, index) {
            return index === _this.variants.findIndex(function(variant) {
                return variant.title.includes(weight);
            });
        });
    };
    /** Returns the cheapest variant */ this.getCheapestVariant = function() {
        var _variants = (0,_to_consumable_array/* default */.Z)(_this.variants);
        return _variants.sort(sortVariants)[0];
    };
    /** Returns the first cheapest subscribable variant (if available) */ this.getFirstCheapestAvailableSubsVariant = function() {
        var _tags = (0,_to_consumable_array/* default */.Z)(_this.tags);
        var _variants = (0,_to_consumable_array/* default */.Z)(_this.variants);
        var variant = _variants.filter(function(variant) {
            return variant.availableForSale;
        }).sort(function(a, b) {
            return +a.priceV2.amount - +b.priceV2.amount;
        })[0];
        return _tags.includes("SubscriptionEnabled") ? variant : null;
    };
    this.isSmartCollectionItem = false;
    this.shouldIgnoreSubtitle = shouldIgnoreSubtitle || false;
    if ((0,utils/* isSmartCollectionItem */.n)(product)) {
        var ref, ref1;
        this.isSmartCollectionItem = true;
        this.variantTitles = product.variant_titles;
        this.id = product.product_id;
        this.productType = product.product_category;
        this.title = product.product_title;
        try {
            // Backend returns bold tag as "** some word** "
            var formattedText = product.subtitle.replace(/\*\*(.*?)\*\*/g, '<span class="font-medium">$1</span>');
            this.subTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: formattedText
                }
            });
        } catch (error) {
            this.subTitle = product.subtitle;
        }
        this.tags = product.tags;
        this.handle = product.slug;
        this.productId = product.product_id.toString();
        this.metadata = (0,_define_property/* default */.Z)({}, MetafieldNameSpaces.Accentuate, {});
        this.availableForSale = product.available;
        this.image.src = product.image_src;
        this.image.alt = product.image_alt || undefined;
        this.variants = [
            {
                availableForSale: product.available,
                image: {
                    alt: product.image_alt || undefined,
                    src: product.image_src
                },
                weight: Number(product.net_grams),
                id: product.variant_id,
                title: product.variant_title,
                sku: product.sku,
                priceV2: {
                    currencyCode: "EUR",
                    amount: product.price
                },
                weightUnit: "GRAMS",
                compareAtPrice: product.compare_price ? Math.round(parseFloat(product.compare_price) * 100) : undefined
            }, 
        ];
        this.createdAt = "0";
        this.ribbonText = (ref = product.ribbon) === null || ref === void 0 ? void 0 : ref.text;
        this.ribbonColor = (ref1 = product.ribbon) === null || ref1 === void 0 ? void 0 : ref1.color;
        this.isBestSeller = product.bestseller;
        this.variantLength = product.variant_length;
    /** @TODO : assertIsStaticPDPProduct is pretty weak check  */ } else if (assertIsStaticPDPProduct(product)) {
        this.id = typeof product.id === "number" ? "".concat(product.id) : product.id;
        this.productType = product.productType;
        this.title = product.title || product.metadata.accentuate.mainTitle;
        this.tags = product.tags;
        this.handle = product.handle;
        this.productId = product.id + "";
        this.metadata = product.metadata;
        this.availableForSale = product.variants.some(function(variant) {
            return variant.availableForSale;
        });
        /**
       * Due to the different implementation on BE, compareAtPrice could be number e.g 4999 or string e.g "49.99"
       * Therefore we align it to be number type without decimal.
       */ this.variants = product.variants.map(function(variant) {
            var _compareAtPrice;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                id: variant.id + "",
                image: {
                    src: variant.image.originalSrc,
                    alt: variant.image.altText || ""
                },
                weightUnit: variant.weightUnit,
                compareAtPrice: (_compareAtPrice = variant.compareAtPrice) !== null && _compareAtPrice !== void 0 ? _compareAtPrice : undefined
            });
        });
        this.variantLength = product.variants.length;
        this.image.src = product.variants[0].image.originalSrc;
        this.image.alt = product.variants[0].image.altText || "";
        this.createdAt = "0";
        this.promoteVariantId = product.id + "";
    } else {
        var ref2;
        this.id = product.masterProductId ? product.masterProductId + "" : product.id + "";
        this.productType = product.productType;
        this.title = product.title || ((ref2 = product.metadata.accentuate) === null || ref2 === void 0 ? void 0 : ref2.mainTitle);
        this.tags = product.tags;
        this.handle = product.handle;
        this.productId = product.productId;
        this.metadata = product.metadata;
        this.availableForSale = product.variants.some(function(variant) {
            return variant.availableForSale;
        });
        /**
       * Due to the different implementation on BE, compareAtPrice could be number e.g 4999 or string e.g "49.99"
       * Therefore we align it to be number type without decimal.
       */ this.variants = product.variants.map(function(variant) {
            var compareAtPrice = variant.compareAtPrice ? isString_default()(variant.compareAtPrice) ? +variant.compareAtPrice * 100 : variant.compareAtPrice : undefined;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                id: variant.id + "",
                compareAtPrice: compareAtPrice
            });
        });
        this.variantLength = product.variants.length;
        this.image.src = product.image.src;
        this.image.alt = product.image.alt;
        var ref3;
        this.createdAt = (ref3 = product["createdAt"]) !== null && ref3 !== void 0 ? ref3 : "0";
        this.promoteVariantId = product.masterProductId ? product.id + "" : undefined;
    }
    if (!assertIsSmartCollectionProduct(product) && !assertIsStaticPDPProduct(product)) {
        this.isStaticCollectionItem = true;
        if (product.segmentation && Object.values(product.segmentation).length > 0) {
            this.segmentation = product.segmentation;
        }
    }
};


/***/ }),

/***/ 36602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CatGeneralCdpHandle; }
/* harmony export */ });
var CatGeneralCdpHandle = {
    CatAllFeedTypesHandle: "fur-katzen-alle-fleischsorten",
    CatWetFoodHandle: "fur-katzen-nassfutter",
    CatDryFoodHandle: "fur-katzen-trockenfutter",
    CatSnacksHandle: "fur-katzen-snacks"
};


/***/ }),

/***/ 75611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ DogGeneralCdpHandle; }
/* harmony export */ });
var DogGeneralCdpHandle = {
    DogWetFoodHandle: "fur-hunde-nassfutter",
    DogDryFoodHandle: "fur-hunde-trockenfutter",
    DogSnacksHandle: "fur-hunde-snacks"
};


/***/ }),

/***/ 32889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useReviewsCacheStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

/**
 * Zustand Store to cache parsed reviews from JudgeMe API
 */ var useReviewsCacheStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        reviews: {},
        setReviews: function(updateFunction) {
            return set(function(state) {
                return {
                    reviews: updateFunction(state.reviews)
                };
            });
        }
    };
});


/***/ }),

/***/ 29898:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var hasPersonalizedDiscount = function(/** @TODO : change it to tags : array<string> */ product, globalDiscount) {
    var isSubscription = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (globalDiscount.loading || !globalDiscount.discount || !isSubscription && globalDiscount.discount && globalDiscount.discount.amountInPercent === 0 || isSubscription && globalDiscount.discount && globalDiscount.discount.firstSubscriptionOrderDiscount === 0) return false;
    if (globalDiscount.discount.productTag) {
        if (// If tagType = include, return normal price if tag is not present
        (globalDiscount.discount.tagType === "include" && (product === null || product === void 0 ? void 0 : product.tags.indexOf(globalDiscount.discount.productTag)) === -1) || // if tagType = exclude, return normal price if tag is present
        (globalDiscount.discount.tagType === "exclude" && (product === null || product === void 0 ? void 0 : product.tags.indexOf(globalDiscount.discount.productTag)) > -1)) return false;
    }
    return true;
};
/* harmony default export */ __webpack_exports__["Z"] = (hasPersonalizedDiscount);


/***/ }),

/***/ 8181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ parseReviews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80969);



var ratingRegex = /data-average-rating='([\d.]+)'/;
var reviewsRegex = /data-number-of-reviews='([\d.]+)'/;
/**
 * Parse html string to retrieve ratings and reviews
 */ var parseReviews = function(param) {
    var rawReviews = param.rawReviews;
    return Object.entries(rawReviews).map(function(entry) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Array.from(entry[1].match(ratingRegex) || []), 2), _ratingCount = ref[1];
        var ratingCount = _ratingCount;
        var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Array.from(entry[1].match(reviewsRegex) || []), 2), _reviewsCount = ref1[1];
        var reviewsCount = _reviewsCount;
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, entry[0], {
            ratingCount: ratingCount,
            reviewsCount: reviewsCount
        });
    }).reduce(function(prev, current) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev, current);
    }, {});
};


/***/ }),

/***/ 92284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jo": function() { return /* binding */ transformCollectionProductToUpsellProduct; },
/* harmony export */   "Ui": function() { return /* binding */ formatTitle; },
/* harmony export */   "_l": function() { return /* binding */ isSubscriptionEnabled; },
/* harmony export */   "lk": function() { return /* binding */ createCrossSellProductDetails; },
/* harmony export */   "xU": function() { return /* binding */ minusPercent; }
/* harmony export */ });
/* unused harmony exports getPricePerKilo, ProductPetType, getProductPetTypeByTags */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var api_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94070);
/* harmony import */ var constants_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42421);





/**
 * Check if it is possible to activate a subscription for the product
 */ var isSubscriptionEnabled = function(productTags, productId) {
    typeof productTags === "string" && (productTags = productTags.split(",").map(function(tag) {
        return tag.trim();
    }));
    // this array contains the IDs of the products for which the subscription is disabled no matter what, even if the products contain the tag 'SubscriptionEnabled'.
    // This may be due to marketing decisions.
    // e.g. see: https://petsdeli.atlassian.net/browse/PT-3934
    var PRODUCTS_TO_DISABLE_SUBSCRIPTION = [
        7996787294474,
        7996772843786
    ];
    if (PRODUCTS_TO_DISABLE_SUBSCRIPTION.includes(productId)) return false;
    return (productTags || "").includes("SubscriptionEnabled");
};
/**
 * Returns the price per kilo of the product
 */ var getPricePerKilo = function(price, variant) {
    var productWeight = variant && (variant.weightUnit === "GRAMS" ? variant.weight / 1000 : variant.weight);
    return price / productWeight;
};
/**
 * Returns the price minus the selected percentage
 * @param {number }n - The original product price
 * @param {number} p - The percentage to be subtracted
 * @returns {number} - The price minus the percentage
 */ var minusPercent = function(n, p) {
    return +(n - n * (p / 100)).toFixed(2);
};
/**
 * Format the title of the product
 */ var formatTitle = function(title) {
    return title.replace(/\s\(\dweek\)/, "");
};
var ProductPetType = {
    /** Product for dog */ Dog: "Dog",
    /** Product for cat */ Cat: "Cat"
};
/**
 * Identify product pet type by tags
 */ var getProductPetTypeByTags = function(tags) {
    if (tags.some(function(tag) {
        return tag === PetTag.Dog;
    })) {
        return ProductPetType.Dog;
    } else if (tags.some(function(tag) {
        return tag === PetTag.Cat;
    })) {
        return ProductPetType.Cat;
    } else {
        return undefined;
    }
};
/**
 * Transform collection product to cart upsell product data
 * @param {CollectionProductResponse} product - The collection product data
 * @returns {CartUpsellProductDetails} - The upsell product data
 */ var transformCollectionProductToUpsellProduct = function(product, cheapestVariant) {
    var variant = cheapestVariant ? product.variants.sort(function(a, b) {
        return Number(a.priceV2.amount) - Number(b.priceV2.amount);
    })[0] : product.variants[0];
    return {
        availableForSale: variant.availableForSale,
        handle: product.handle,
        id: product.id,
        image: variant.image.src,
        price: Number(variant.priceV2.amount),
        productId: product.id,
        productTitle: product.title,
        productType: product.productType,
        promoteVariantId: product.masterProductId ? product.id : undefined,
        quantity: 1,
        sku: variant.sku,
        tags: product.tags.toString(),
        title: product.title,
        variantId: variant.id,
        variantTitle: variant.title
    };
};
/**
 * Fetch product details and return the data in the format of the upsell product
 */ var createCrossSellProductDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(handle, variantId) {
        var productDetails, targetVariant, returnData, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,api_product__WEBPACK_IMPORTED_MODULE_0__/* .fetchProductDetails */ .g3)(handle)
                    ];
                case 1:
                    productDetails = _state.sent();
                    targetVariant = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.variants.find(function(variant) {
                        return variant.id === variantId;
                    });
                    if (!productDetails || !targetVariant) return [
                        2,
                        null
                    ];
                    _tmp = {};
                    _tmp1 = {};
                    returnData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_tmp.availableForSale = targetVariant.availableForSale, _tmp.handle = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.handle, _tmp.price = +targetVariant.priceV2.amount * 100, _tmp.sku = targetVariant === null || targetVariant === void 0 ? void 0 : targetVariant.sku, _tmp.variantId = variantId, _tmp.productId = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.id, _tmp.productTitle = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.title, _tmp.productType = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.productType, _tmp.variantTitle = targetVariant === null || targetVariant === void 0 ? void 0 : targetVariant.title, _tmp.tags = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.tags.toString(), _tmp.quantity = 1, _tmp.description = productDetails === null || productDetails === void 0 ? void 0 : productDetails.product.description, _tmp.image = targetVariant.image.originalSrc, _tmp), targetVariant.compareAtPrice && (_tmp1.compareAtPrice = +targetVariant.compareAtPrice * 100, _tmp1));
                    return [
                        2,
                        returnData
                    ];
            }
        });
    });
    return function createCrossSellProductDetails(handle, variantId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);